import BaseLayoutView from 'app/src/views/base/BaseLayoutView';
import PaymentType from 'app/src/data/models/PaymentType';
import GatewayConfig from 'app/src/data/models/GatewayConfig';
import Format from 'app/src/data/Format';
import $ from 'jquery';
import gatewayDetailView from './templates/gateway-detail-view.hbs';

const _Events = {
  GATEWAY_CHANGED: 'gateway:changed',
};

// configure
let View = BaseLayoutView.extend({
  template: gatewayDetailView,

  regions: {
    content: '#view',
  },

  ui: {
    gatewaySelect: '#gateway_select',
    gatewaySpecificForm: '.gateway-specific-form',
    paymentMappingSelect: 'select[id$="_mapping_select"]',
    debitMappingSelect: '#debit_mapping_select',
    allowCredits: '.allow-credits',
    partialApprovals: '#allow_partial_approvals',
    checkForDuplicateTransactions: '#prevent_duplicates',
    swipersEnabled: '#swipers_enabled',
    // merchantReceipt: '.merchant-receipt',
  },

  events: {
    'change @ui.gatewaySelect': 'onGatewaySelect',
  },
});

// define
export default class GatewayDetailView extends View {
  static get Events() {
    return _Events;
  }

  /**
   * Event handler called before the view is rendered.
   */
  onBeforeRender() {
    window.Handlebars.registerHelper(
      'hasAssignedGateway',
      shop =>
        (shop.CCGateway && shop.CCGateway.gateway) ||
        (shop.gatewayConfigID && shop.gatewayConfigID.match && shop.gatewayConfigID.match(/-/))
    );
  }

  /**
   * Event handler called before the view is destroyed.
   */
  onBeforeDestroy() {
    window.Handlebars.unregisterHelper('hasAssignedGateway');
  }

  /**
   * To preset all of the paymentType dropdowns to the appropriate ones.
   */
  setPaymentMappings(gatewayConfig) {
    if (gatewayConfig instanceof GatewayConfig) {
      gatewayConfig.get('cardSchemeMappings').CardSchemeMapping.forEach(paymentType => {
        const cardSchemeID = paymentType.cardSchemeID;
        const paymentTypeID = paymentType.paymentTypeID;

        $(`#${cardSchemeID}_mapping_select option[value=${paymentTypeID}]`).prop('selected', true);
      });
    } else {
      $('select[id$="_mapping_select"] option:contains(\'Credit Card\')').prop('selected', true);
      $("#debit_mapping_select option:contains('Debit Card')").prop('selected', true);
    }
  }

  /**
   * Event trigger for when the Gateway Dropdown is Changed
   */
  onGatewaySelect(gatewayConfig) {
    this.ui.gatewaySpecificForm.show();
    this.resetGatewayFormElements();

    // gatewayConfig is either an event if nothing is initialized,
    // or a gatewayConfig object if it is. Try to use it as its object
    // to grab the gatewayID; if that errors out, it's because this is
    // a new Gateway being configured. Use the dropdown value instead.
    let gatewaySelectVal = null;
    try {
      gatewaySelectVal = gatewayConfig.get('gatewayID');
    } catch (e) {
      gatewaySelectVal = this.ui.gatewaySelect.val();
    }

    this.showGatewayFormElements(gatewaySelectVal);
    this.setPaymentMappings(gatewayConfig);
  }

  /**
   * Resets(shows/hides) all form elements which are particular to the Gateway type
   */
  resetGatewayFormElements() {
    $('[class$="config"]').hide();
    // FIXME: Less-than-ideal solution to reset parts of the page that can be hidden depending on the gateway
    $('[class$="config-hide"]').show();
  }

  /**
   * Shows/hides the form elements which are particular to the Gateway type
   */
  showGatewayFormElements(selectedGateway) {
    $(`.${selectedGateway}-config`).show();
    // FIXME: Less-than-ideal solution to hide some parts of the page depending on the gateway (opposite of above)
    $(`.${selectedGateway}-config-hide`).hide();
  }

  /**
   * Quick Form Validation to ensure a Gateway is Selected,
   * and all text inputs have a value.
   *
   * @returns {boolean}
   */
  formFieldValidation() {
    let formIsValid = true;
    let formErrorMsg = '';

    // If the dropdown exits on the page and nothing is selected,
    // error out
    if (this.ui.gatewaySelect.length > 0 && !this.ui.gatewaySelect.val()) {
      formIsValid = false;
      formErrorMsg = 'A Gateway must be selected';
    }

    $('.required:visible').each(function() {
      if (formIsValid) {
        if (!$(this).val()) {
          formIsValid = false;
          formErrorMsg = 'Please fill out all of the Required Form Fields';
        }
      }
    });

    if (!formIsValid) {
      alertUser(formErrorMsg);
    }

    return formIsValid;
  }

  /**
   * Returns the Form Values from the UI Form Fields
   *
   * @returns {{name: (*|jQuery), gatewayID: (*|jQuery), parameters: {},
   *            cardSchemeMappings: {CardSchemeMapping: Array}}}
   */
  getFormFieldValues() {
    let gatewayType = $('#gateway_select').val();

    // The dropdown only exists when ADDING a gateway.
    // When EDITING a gateway, instead use the original GatewayID
    // since we can no longer edit the Gateway Type (as of CLD-13469).
    if (this.viewData.gatewayID) {
      gatewayType = this.viewData.gatewayID;
    }

    let formFieldValues = {
      name: $('.gateway-name').val(),
      gatewayID: gatewayType,
      parameters: {},
      cardSchemeMappings: {
        CardSchemeMapping: [],
      },
    };

    /**
     * Gateway Parameters (Required)
     */
    $(`.${gatewayType}-config > .table-row > dd > input[type='text'],
            .${gatewayType}-config > .table-row > dd > input[type='password']`).each(function() {
      formFieldValues.parameters[$(this).data('name')] = $(this).val();
    });

    const allowCredits = $('.allow-credits:visible');
    if (allowCredits.length) {
      formFieldValues.parameters[allowCredits.data('name')] = allowCredits.is(':checked');
    }

    const allowPartialApprovals = $('#allow_partial_approvals:visible');
    if (allowPartialApprovals.length) {
      formFieldValues.parameters[allowPartialApprovals.data('name')] = allowPartialApprovals.is(
        ':checked'
      );
    }

    const checkForDuplicateTransactions = $('#prevent_duplicates:visible');
    if (checkForDuplicateTransactions.length) {
      formFieldValues.parameters[
        checkForDuplicateTransactions.data('name')
      ] = checkForDuplicateTransactions.is(':checked');
    }

    const swipersEnabled = $('#swipers_enabled:visible');
    if (swipersEnabled.length) {
      formFieldValues.parameters[swipersEnabled.data('name')] = swipersEnabled.is(':checked');
    }

    /**
     * Gateway Card Scheme Mapping
     */
    $('.payment-mapping select').each(function() {
      formFieldValues.cardSchemeMappings.CardSchemeMapping.push({
        cardSchemeID: $(this).data('name'),
        paymentTypeID: $(this).val(),
      });
    });

    return formFieldValues;
  }

  /**
   * Sets the form fields using the GatewayConfig Object.
   * Shop Gateway Assignment is done separately as it is tied to the shop settings.
   * Card Mapping is set separately due to it is tied to the Payment Types settings.
   *
   * @param gatewayConfig {object}    Gateway Information
   */
  setFormFieldValues(gatewayConfig) {
    this.onGatewaySelect(gatewayConfig);

    if (gatewayConfig.get('parameters')) {
      if (gatewayConfig.get('parameters').allowCredits === 'true') {
        this.ui.allowCredits.prop('checked', true);
      }

      if (gatewayConfig.get('parameters').partialApprovals === 'true') {
        this.ui.partialApprovals.prop('checked', true);
      }

      if (gatewayConfig.get('parameters').checkForDuplicateTransactions === 'true') {
        this.ui.checkForDuplicateTransactions.prop('checked', true);
      }

      if (gatewayConfig.get('parameters').swipersEnabled === 'true') {
        this.ui.swipersEnabled.prop('checked', true);
      }
    }
  }

  /**
   * Shop - Gateway assignment
   * Returns the Checkbox values that assigns the store to the Gateway
   *
   * @returns {Array}
   */
  getShopFormFieldValues() {
    let selectedShops = {};

    $('.shop-gateway-assignment input[type="checkbox"]').each(function() {
      if ($(this).is(':checked')) {
        selectedShops[`shop_${$(this).val()}`] = Format.parseInt($(this).val());
      }
    });

    return selectedShops;
  }
}
